import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const ArrowLink = ({ to, children, light = false, testid }) => (
  <Link
    to={to}
    data-testid={testid}
    className={`group inline-flex items-center gap-4 font-caps text-[12px] tracking-[0.24em] uppercase ${light ? "text-ivory" : "text-heritage"}`}
  >
    <span className="relative">
      {children}
      <span className="absolute -bottom-1 left-0 h-px w-full origin-left scale-x-100 bg-gold transition-transform duration-500 group-hover:scale-x-50" />
    </span>
    <span className="grid h-11 w-11 place-items-center rounded-full border border-gold transition-[background-color,transform] duration-500 group-hover:rotate-45 group-hover:bg-gold">
      <ArrowUpRight size={16} />
    </span>
  </Link>
);
